import { amountToDisplayValue, Color, Flex, SkeletonBox, Space, Text } from '@billy/design-system'
import React, { ReactElement, ReactNode } from 'react'

import * as Styled from './styles'

interface PurchaseCardPriceSectionProps {
  isLoading?: boolean
  price?: number
  pricePeriodNode?: ReactNode
  priceSuffix: string
}

export const PurchaseCardPriceSection = ({
  isLoading,
  price,
  pricePeriodNode,
  priceSuffix,
}: PurchaseCardPriceSectionProps): ReactElement => {
  return (
    <Styled.PurchaseCardPriceSectionWrapper flexDirection="column" alignItems="center">
      {pricePeriodNode && <Styled.PricePeriodWrapper>{pricePeriodNode}</Styled.PricePeriodWrapper>}
      <Styled.PriceWrapper>
        {/* !price would be incorrect here, because it can be 0 */}
        {isLoading || price === undefined ? (
          <SkeletonBox fullWidth fullHeight />
        ) : (
          <Flex justifyContent="center" alignItems="baseline">
            <Text variant="display" color={Color.Lavender500} weight="bold">
              {amountToDisplayValue(price, true)}
            </Text>
            <Space horizontal size="s4" />
            <Text variant="h2" color={Color.Lavender500}>
              {priceSuffix}
            </Text>
          </Flex>
        )}
      </Styled.PriceWrapper>
    </Styled.PurchaseCardPriceSectionWrapper>
  )
}
